<a *ngIf="showAddButton" (click)="this.addResolutionFromBackend()"><span class="text">+Add</span></a>
<a *ngIf="!showAddButton" (click)="this.addResolutionFromBackend()"><span class="text">See Resolution</span></a>
